<template>
  <v-form v-model="valid">
    <v-row>
      <v-col cols="12" lg="6">
        <v-row dense>
          <v-col cols="12">
            <span class="text-6">{{ $t('APP_LAYOUT.TOP_BAR.TITLE') }}</span>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="localLayoutData.top_bar_color"
              :rules="hexRules"
              maxlength="6"
              :label="`${$t('APP_LAYOUT.TOP_BAR.COLOR')}`"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="localLayoutData.top_bar_font_color"
              :rules="hexRules"
              maxlength="6"
              :label="`${$t('APP_LAYOUT.TOP_BAR.FONT_COLOR')}`"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="localLayoutData.top_bar_icons_color"
              :rules="hexRules"
              maxlength="6"
              :label="`${$t('APP_LAYOUT.TOP_BAR.ICON_COLOR')}`"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <span class="text-6">{{ $t('APP_LAYOUT.HOME_SCREEN.TITLE') }}</span>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="localLayoutData.tiles_color"
              :rules="hexRules"
              maxlength="6"
              :label="`${$t('APP_LAYOUT.HOME_SCREEN.TILES_COLOR')}`"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="localLayoutData.tiles_icon_color"
              :rules="hexRules"
              maxlength="6"
              :label="`${$t('APP_LAYOUT.HOME_SCREEN.TILES_ICON_COLOR')}`"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="localLayoutData.tiles_font_color"
              :rules="hexRules"
              maxlength="6"
              :label="`${$t('APP_LAYOUT.HOME_SCREEN.TILES_FONT_COLOR')}`"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="localLayoutData.notruf_tile_color"
              :rules="hexRules"
              maxlength="6"
              :label="`${$t('APP_LAYOUT.HOME_SCREEN.NOTRUF_TILE_COLOR')}`"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="localLayoutData.notruf_tile_font_color"
              :rules="hexRules"
              maxlength="6"
              :label="`${$t('APP_LAYOUT.HOME_SCREEN.NOTRUF_TILE_FONT_COLOR')}`"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="localLayoutData.notruf_tile_icon_color"
              :rules="hexRules"
              maxlength="6"
              :label="`${$t('APP_LAYOUT.HOME_SCREEN.NOTRUF_TILE_ICON_COLOR')}`"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <span class="text-6">{{ $t('APP_LAYOUT.BOTTOM_BAR.TITLE') }}</span>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="localLayoutData.bottom_bar_color"
              :rules="hexRules"
              maxlength="6"
              :label="`${$t('APP_LAYOUT.BOTTOM_BAR.COLOR')}`"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="localLayoutData.bottom_bar_icons_color"
              :rules="hexRules"
              maxlength="6"
              :label="`${$t('APP_LAYOUT.BOTTOM_BAR.ICONS_COLOR')}`"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="localLayoutData.bottom_bar_font_color"
              :rules="hexRules"
              maxlength="6"
              :label="`${$t('APP_LAYOUT.BOTTOM_BAR.FONT_COLOR')}`"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <span class="text-6">{{
              $t('APP_LAYOUT.ADDITIONAL_COLORS.TITLE')
            }}</span>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="localLayoutData.buttons_color"
              :rules="hexRules"
              maxlength="6"
              :label="`${$t('APP_LAYOUT.ADDITIONAL_COLORS.BUTTONS_COLOR')}`"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="localLayoutData.buttons_font_color"
              :rules="hexRules"
              maxlength="6"
              :label="
                `${$t('APP_LAYOUT.ADDITIONAL_COLORS.BUTTONS_FONT_COLOR')}`
              "
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="localLayoutData.links_color"
              :rules="hexRules"
              maxlength="6"
              :label="
                `${$t('APP_LAYOUT.ADDITIONAL_COLORS.LINKS_COLOR')}`
              "
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <span class="text-6">{{ $t('APP_LAYOUT.FONT.TITLE') }}</span>
          </v-col>
          <v-col cols="4">
            <v-select
              v-model="localLayoutData.font"
              :rules="rules.required"
              :items="['Roboto']"
              :label="`${$t('APP_LAYOUT.FONT.FONT_FAMILY')}`"
              disabled
            ></v-select>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" lg="6">
        <v-row dense>
          <v-col cols="12">
            <span class="text-6">{{ $t('APP_LAYOUT.DEMO.TITLE') }}</span>
          </v-col>
          <v-col cols="12">
            <v-sheet
              color="grey lighten-3"
              height="600px"
              class="d-flex justify-center align-center"
            >
              <v-sheet
                width="60%"
                max-width="400px"
                height="90%"
                class="d-flex flex-column justify-space-between pa-2"
                elevation="20"
              >
                <v-sheet
                  height="50px"
                  width="100%"
                  :color="`#${localLayoutData.top_bar_color}`"
                  class="d-flex justify-space-between align-center px-4"
                >
                  <v-icon
                    :color="`#${localLayoutData.top_bar_icons_color}`"
                    v-text="'mdi-menu'"
                  />
                  <span
                    class="text-h6"
                    :style="`color: #${localLayoutData.top_bar_font_color}`"
                  >
                    {{ $t('APP_LAYOUT.DEMO.COPYRIGHT') }}
                  </span>
                  <v-icon
                    :color="`#${localLayoutData.top_bar_icons_color}`"
                    v-text="'mdi-arrow-left-circle'"
                  />
                </v-sheet>

                <v-sheet class="text-center mt-1 mb-auto">
                  <v-row dense>
                    <v-col cols="6">
                      <v-sheet
                        height="140px"
                        :color="`#${localLayoutData.tiles_color}`"
                        class="d-flex flex-column justify-center"
                      >
                        <v-icon
                          size="60"
                          :color="`#${localLayoutData.tiles_icon_color}`"
                          v-text="'mdi-room-service-outline'"
                        />
                        <span
                          class="text-h6"
                          :style="`color: #${localLayoutData.tiles_font_color}`"
                        >
                          {{ $t('APP_LAYOUT.DEMO.CONCIERGE') }}</span
                        >
                      </v-sheet>
                    </v-col>
                    <v-col cols="6">
                      <v-sheet
                        height="140px"
                        :color="`#${localLayoutData.notruf_tile_color}`"
                        dark
                        class="d-flex flex-column justify-center"
                      >
                        <v-icon
                          size="60"
                          :color="`#${localLayoutData.notruf_tile_icon_color}`"
                          v-text="'mdi-phone-in-talk'"
                        />
                        <span
                          class="text-h6"
                          :style="
                            `color: #${localLayoutData.notruf_tile_font_color}`
                          "
                        >
                          {{ $t('APP_LAYOUT.DEMO.NOTRUF') }}</span
                        >
                      </v-sheet>
                    </v-col>
                    <v-col cols="6">
                      <v-sheet
                        height="140px"
                        :color="`#${localLayoutData.tiles_color}`"
                        class="d-flex flex-column justify-center"
                      >
                        <v-icon
                          size="60"
                          :color="`#${localLayoutData.tiles_icon_color}`"
                          v-text="'mdi-face-agent'"
                        />
                        <span
                          class="text-h6"
                          :style="`color: #${localLayoutData.tiles_font_color}`"
                        >
                          {{ $t('APP_LAYOUT.DEMO.SERVICES') }}</span
                        >
                      </v-sheet>
                    </v-col>
                  </v-row>
                </v-sheet>

                <v-sheet class="text-center mt-auto">
                  <v-row>
                    <v-col>
                      <v-btn
                        block
                        :color="`#${localLayoutData.buttons_color}`"
                        class="text-none font-weight-regular"
                        :style="`color: #${localLayoutData.buttons_font_color}`"
                      >
                        {{ $t('APP_LAYOUT.DEMO.BUTTON') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-sheet>

                <v-sheet
                  height="50px"
                  width="100%"
                  :color="`#${localLayoutData.bottom_bar_color}`"
                  class="d-flex flex-column justify-center align-center"
                >
                  <v-icon
                    :color="`#${localLayoutData.bottom_bar_icons_color}`"
                    v-text="'mdi-home'"
                  />
                  <span
                    class="text-caption"
                    :style="`color: #${localLayoutData.bottom_bar_font_color}`"
                  >
                    {{ $t('APP_LAYOUT.DEMO.HOME') }}
                  </span>
                </v-sheet>
              </v-sheet>
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="auto">
        <slot name="buttons" :valid="valid" />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { isEmpty, isEqual } from 'lodash';
import { requiredTextLine } from '@/modules/_global/variables/rules.js';

export default {
  name: 'AppLayoutForm',

  model: {
    prop: 'layoutData',
    event: 'input'
  },

  props: {
    layoutData: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    valid: true,

    rules: {
      required: requiredTextLine
    },

    localLayoutData: {}
  }),

  computed: {
    hexRules() {
      return [
        v =>
          !!v.match(/^[0-9A-Fa-f]{6}$/) ||
          this.$t('MESSAGE.THIS_FIELD_MUST_BE_VALID')
      ];
    }
  },

  watch: {
    layoutData: {
      deep: true,
      handler() {
        if (!isEqual(this.layoutData, this.localLayoutData)) {
          this.setLocalLayoutData();
        }
      }
    },

    localLayoutData: {
      deep: true,
      handler: 'updateLayoutData'
    }
  },

  created() {
    // if we are in 'edit' mode
    this.setLocalLayoutData();
  },

  methods: {
    setLocalLayoutData() {
      if (!isEmpty(this.layoutData)) {
        this.localLayoutData = { ...this.layoutData };
        return;
      }

      this.initLayoutData();
    },

    updateLayoutData() {
      this.$emit('input', { ...this.localLayoutData });
    },

    initLayoutData() {
      this.localLayoutData = {
        top_bar_color: 'eeeeee',
        top_bar_font_color: '333333',
        top_bar_icons_color: '333333',

        tiles_color: 'eeeeee',
        tiles_icon_color: '333333',
        tiles_font_color: '333333',

        notruf_tile_color: 'ff5555',
        notruf_tile_icon_color: 'ffffff',
        notruf_tile_font_color: 'ffffff',

        bottom_bar_color: 'eeeeee',
        bottom_bar_icons_color: '333333',
        bottom_bar_font_color: '333333',

        buttons_color: 'eeeeee',
        buttons_font_color: '333333',
        links_color: '333333',

        font: 'Roboto'
      };
    }
  }
};
</script>
